export const SHOW_VALIDATION_ERROR = 'SHOW_VALIDATION_ERROR';

export const DISMISS_VALIDATION_ERROR = 'DISMISS_VALIDATION_ERROR';

export const showValidationError = payload => dispatch =>
  dispatch({
    type: SHOW_VALIDATION_ERROR,
    payload,
  });

export const dismissValidationError = () => dispatch =>
  dispatch({
    type: DISMISS_VALIDATION_ERROR,
  });
